const setChartsSettings = (state, action) => {
  state.chartsSettings = action.payload;
};

export default { setChartsSettings };
